module.exports = __webpack_public_path__ + "img/eh.96866b5d.svg";